import type { LaneDependencyRelation, LaneSyncBadge, TimelineCrossLaneCoupling } from "./sync.types";

export function selectDependencyRelationsForLane(relations: LaneDependencyRelation[], laneId: string): LaneDependencyRelation[] {
  return relations.filter((relation) => relation.fromLaneId === laneId || relation.toLaneId === laneId);
}

export function selectOutgoingDependencyRelations(relations: LaneDependencyRelation[], laneId: string): LaneDependencyRelation[] {
  return relations.filter((relation) => relation.fromLaneId === laneId);
}

export function selectLaneSyncBadge(syncBadgesByLaneId: Record<string, LaneSyncBadge>, laneId: string): LaneSyncBadge | null {
  return syncBadgesByLaneId[laneId] ?? null;
}

export function selectCrossLaneCouplingsFromMetadata(metadata?: Record<string, unknown> | null): TimelineCrossLaneCoupling[] {
  return Array.isArray(metadata?.crossLaneCouplings)
    ? metadata.crossLaneCouplings as TimelineCrossLaneCoupling[]
    : [];
}

export function selectCrossLaneCouplingsForId(couplings: TimelineCrossLaneCoupling[], id: string): TimelineCrossLaneCoupling[] {
  return couplings.filter((coupling) => coupling.sourceId === id || coupling.targetId === id);
}

export function selectCrossLaneCouplingsForTarget(couplings: TimelineCrossLaneCoupling[], targetId: string): TimelineCrossLaneCoupling[] {
  return couplings.filter((coupling) => coupling.targetId === targetId);
}